import actionTypes from '../actionTypes';

/*  

  define agentList for one to one agent mapping
  agentList :: agentList["devid"] = {"state":"","timestamp":"","extraInfo"}

  filter :: define for filter
  filter :: {"startDate":"","endDate":""}

  stateList => Define for agent state list array
  
  monitorStats => Define for all call count


*/
const initialState = {
  agentList: {},
  filter: {},
  stateList: {},
  queue: {},
  liveChatData: {},
  liveTranscription: [],
  liveTranscriptionUpdate: [],
  chatSummary: {
    // topic:
    //   "Customer is looking to get the Roadside Assistance Flat Tire Service",
    // summary:
    //   "The customer, Rahul Pathak, had a flat tire and contacted ASAI Insurance for roadside assistance. He provided his location and vehicle details, and a technician was assigned to assist him. The conversation included the customer's policy number, date of birth, phone numbers, and email address.",
    // type: "Roadside Assistance",
    // intent: "Related",
    // tags: "Roadside Assistance, Flat Tire, ASAI Insurance",
    // moderation: "No",
    // tl_nsfw: "No",
    // confidence_score: "90",
    // confidence_score_exp:
    //   "The conversation was straightforward and provided all necessary information for the roadside assistance request.",
    // pii: "Yes",
    // pii_info:
    //   "Policy number: P020035678904, Date of birth: 1989-03-25, Phone numbers: 2245213388, 12245213388, Email address: JONEVANS407@EMAILNET.COM",
    // pci: "No",
    // pci_info: "None",
    // ai_rating_for_user_question: "5",
    // ai_rating_exp_for_user_question:
    //   "The customer provided clear and relevant information for the roadside assistance request.",
    // ai_rating_for_ai_response: "5",
    // ai_rating_exp_for_ai_response:
    //   "The responses provided were accurate and helpful in resolving the customer's issue.",
    // sentiment: "Neutral",
    // language: "English",
    // is_conversation_complete: "Yes",
    // is_escalation_necessary: "No",
    // static__policy_no: "P020035678904",
    // static__date_of_birth: "1989-03-25",
    // static__work_phone: "12245213388",
    // static__home_phone: "2245213388",
    // static__email: "JONEVANS407@EMAILNET.COM",
    // static__first_name: "Rahul",
    // static__last_name: "Pathak",
    // static__city: "Naperville",
    // static__country: "USA",
    // entities:
    //   "Customer Name: Rahul Pathak, Policy Number: P020035678904, Date of Birth: 1989-03-25, Phone Number: 2245213388, Email Address: JONEVANS407@EMAILNET.COM, Vehicle Make: Honda, Vehicle Model: CRV, Vehicle Year: 2020, Vehicle Color: Red, Location: 25 South Commons Drive, Aurora, Illinois 60504, USA",
  },
  chatSummaryLoading: false,
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.LIVE_AGENT_LIST:
      newState.agentList = action.payload.data;
      return newState;
    case actionTypes.LIVE_FILTER:
      newState.filter = action.payload.data;
      return newState;
    case actionTypes.LIVE_STATE_LIST:
      newState.stateList = action.payload.data;
      return newState;
    case actionTypes.LIVE_QUEUE:
      newState.queue = action.payload.data;
      return newState;
    case actionTypes.LIVE_SET_AGENT_LIST:
      if (action.payload.key && action.payload.value)
        newState.agentList[action.payload.key] = action.payload.value;
      return newState;
    case actionTypes.LIVE_SET_FILTER:
      if (action.payload.key && action.payload.value)
        newState.filter[action.payload.key] = action.payload.value;
      return newState;
    case actionTypes.LIVE_SET_STATE_LIST:
      if (action.payload.key && action.payload.value)
        newState.stateList[action.payload.key] = action.payload.value;
      return newState;
    case actionTypes.LIVE_SET_QUEUE:
      if (action.payload.key && action.payload.value)
        newState.queue[action.payload.key] = action.payload.value;
      return newState;
    case actionTypes.LIVE_DYNAMIC_UPDATE:
      if (action.payload.key && action.payload.value)
        newState[action.payload.key] = action.payload.value;
      else if (typeof action.payload == "object" && Object.keys(action.payload).length > 0) {
        for (const key in action.payload) {
          if (key && action.payload[key]) {
            newState[key] = action.payload[key];
          }
        }
      }
      return newState;
    case actionTypes.UPDATE_LIVE_CHAT_DATA:
      if (action.payload) {
        newState.liveChatData = { ...newState.liveChatData, ...action.payload };
      }
      return newState;
    case actionTypes.LIVE_TRANSCRIPTION_SET:
      return {
        ...state,
        liveTranscription: Array.isArray(action.payload.data)
          ? action.payload.data
          : [action.payload.data], // Replace with new data
      };

    case actionTypes.LIVE_TRANSCRIPTION_UPDATE:
      return {
        ...state,
        liveTranscription: Array.isArray(action.payload.data)
          ? [...state.liveTranscription, ...action.payload.data] // Append array data
          : [...state.liveTranscription, action.payload.data], // Append single object
      };
    case actionTypes.LIVE_CLEAR_TRANSCRIPTION:
      newState.liveTranscription = [];
      return newState;
    case actionTypes.CHAT_SUMMARY:
      console.log("[livemonitor.reducer-set]", action.payload.data);
      if (action.payload.data) {
        newState.chatSummary = action.payload.data;
      } else {
        newState.chatSummary = {};
      }
      return newState;
    case actionTypes.CHAT_SUMMARY_LOADING_SET:
      console.log('action.payload.data', action.payload.data)
      newState.chatSummaryLoading = action.payload.data;
      return newState;
    case actionTypes.CHAT_SUMMARY_CLEAR:
      newState.chatSummary = {};
      return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/store/reducers/livemonitor.reducer.js